
interface IVehicleExploreStep {
    type: string,
    handler(prevStepSelectedValue?: string): void;
}


class VehicleExplorer {
    _steps: IVehicleExploreStep[];

    constructor() {
        this._steps = [];
    }

    addVehicleExploreStep(stepType: string, stepHandler : (prevStepSelectedValue?: string) => void) {
        this._steps.push({ type: stepType, handler: stepHandler });
    }

    findStepByType(stepType: string) {
        for (let i = 0; i < this._steps.length; i++) {
            if (this._steps[i].type === stepType)
                return this._steps[i];
        }

        return null;
    }

    findNextStepFor(currentStepType: string) {
        for (let i = 0; i < this._steps.length; i++) {
            if (this._steps[i].type === currentStepType && i < this._steps.length - 1)
                return this._steps[i + 1];
        }

        return null;
    }

    findPrevStepFor(currentStepType: string) {
        for (let i = 0; i < this._steps.length; i++) {
            if (this._steps[i].type === currentStepType && i > 0)
                return this._steps[i - 1];
        }

        return this._steps[0];
    }

    handleNextStepFor(currentStepType: string, value: string) {
        const nextStep = this.findNextStepFor(currentStepType);
        if (nextStep) {
            nextStep.handler(value);
            return true;
        }

        return false;
    }
}

export default VehicleExplorer